import axios from 'axios';
import type { ApprovalDetailResponse, ApprovalParams, ApprovalResponse, UpdateApprovalPayload } from '../types/Approvals';
import { baseUrl } from './base';

export const getApprovals = async (params?: ApprovalParams) => {
  const response = await axios.request<ApprovalResponse>({
    url: `${baseUrl.SHERPA}/approvals`,
    method: 'GET',
    params,
  });
  return response.data;
};

export const getApprovalById = async (id: number) => {
  const response = await axios.request<ApprovalDetailResponse>({
    url: `${baseUrl.SHERPA}/approvals/${id}`,
    method: 'GET',
  });
  return response.data;
};

export const updateApproval = async ({ id, ...data }: UpdateApprovalPayload) => {
  const response = await axios.request({
    url: `${baseUrl.SHERPA}/approvals/${id}`,
    method: 'PATCH',
    data,
  });
  return response.data;
};
